<template>
  <v-col
    v-if="$vuetify.breakpoint.name == 'xs'"
    cols="12"
    class="pa-0 align-center"
    style="height: 100vh;display: flex;margin-top: -70px;"
  >

    <h2 class="text-center">
      <v-icon x-large class="mb-5">mdi-phone-rotate-landscape</v-icon>
      <br />
      Put your phone in landscape mode
    </h2>
  </v-col>
  <v-card v-else fill-height fluid>
    <v-tabs
      v-model="tab"
      background-color="primary"
      dark
    >
      <v-tab
        v-for="item in items"
        :key="item.tab"
        v-if="$store.state.auth.checkAccess({key: item.access, value: true}) || !item.access"
      >
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items touchless v-model="tab">
      <v-tab-item
        v-for="item in items"
        :key="item.tab"
        v-if="$store.state.auth.checkAccess({key: item.access, value: true}) || !item.access"
      >
        <component :is="item.dist" :title="item.tab" :url="item.url" />
      </v-tab-item>
    </v-tabs-items>

  </v-card>
</template>

<style>
  .affiliate_stats-dt thead th {
    white-space: nowrap;
  }

  .affiliate_stats-dt {
    min-height: calc(100vh - 148px);
  }

  .affiliate_stats-dt .v-select__selections {
    display: contents;
  }


  .report-base-filter {
    padding: 12px 8px;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 8.3333333333%;
    flex: 0 0 8.3333333333%;
    max-width: 8.3333333333%;
  }


  .affiliate_stats-sub-dt tr:not(.report-filter-row) {
    counter-increment: row-num;
  }

  .affiliate_stats-sub-dt tr td:first-child .row_num::before {
    content: counter(row-num) ". ";
  }

  .affiliate_stats-sub-dt.v-data-table th,
  .affiliate_stats-dt.v-data-table th {
    padding: 0 6px !important;
  }

  .v-data-table.affiliate_stats-sub-dt td,
  .v-data-table.affiliate_stats-dt td {
    height: 35px !important;
    padding: 3px 6px !important;
  }

</style>

<script>

  export default {

    components: {
      Stats: () => import('@/components/affiliate-stats/Stats'),
      AffiliateDailyExport: () => import('@/components/affiliate-stats/AffiliateDailyExport'),
    },

    data: () => ({
      tab: null,
      items: [
        { tab: 'Statistic', dist: 'stats' },
        { tab: 'Data to Export', dist: 'affiliate-daily-export', access: 'affiliate_export_stats' },
      ]
    }),

    mounted () {
    },

    methods: {},
  }
</script>
